import COLORS from '../../style/universal.color';
import color from 'color';
import { ComponentColorsHollowLight, ComponentColorsSolidDark, ComponentColorsHollowDark, ComponentColorsSolidLight } from '../../style/colors.map';

export interface IndividualButtonColors {
    color?: string;
    borderColor?: string;
    backgroundColor?: string;
    hoverBackgroundColor?: string;
    hoverBorderColor?: string;
    hoverColor?: string;
}

interface HollowSolidButtons {
    disabled?: IndividualButtonColors;
    default?: IndividualButtonColors;
    linkBlue?: IndividualButtonColors;
    ticketGreen?: IndividualButtonColors;
    mlbTvOrange?: IndividualButtonColors;
}

interface LightDarkButtons {
    hollow?: HollowSolidButtons;
    solid?: HollowSolidButtons;
}

interface ButtonColors {
    light?: LightDarkButtons;
    dark?: LightDarkButtons;
}

const {
    mlbWhite,
    mlbGrey7,
    linkBlue,
    transparent
} = COLORS;

// Return the styles needed for a provided team color
export const retrieveTeamColorMap = (teamColor: string = linkBlue, hollowMode: string, themeType: string): IndividualButtonColors => {
    const hollow: boolean = hollowMode === 'hollow'
    const colorMap: IndividualButtonColors = {
      color: hollow ? teamColor : mlbWhite,
      backgroundColor: hollow ? transparent  : teamColor,
      borderColor: hollow ? teamColor : '',
      hoverColor: hollow ? mlbWhite : '',
      hoverBackgroundColor: hollow ? (themeType === 'dark' ? mlbGrey7 : teamColor) : color(teamColor).mix(color('black'), 0.2).hex()
    };
    return colorMap;
}

// A map of all the colors the various button configurations require
export const ButtonColors: ButtonColors = {
    light: {
        hollow: ComponentColorsHollowLight,
        solid: ComponentColorsSolidLight
    },
    dark: {
        hollow: ComponentColorsHollowDark,
        solid: ComponentColorsSolidDark
    }
}
